import { getAlignItems } from 'particles/utils'
import styled from '../themes/styled'
import { CheckboxSize, sizeMap } from './index'
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox'
import { TextScale } from 'particles/Text'

interface StyledCheckboxContainerProps {
    textScale: TextScale
    iconSize: CheckboxSize
    containerHeight?: number
}

export const StyledCheckboxContainer = styled.div<StyledCheckboxContainerProps>`
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing[200]};
    align-items: ${({ theme, textScale, containerHeight }) => getAlignItems(theme, textScale, containerHeight)};
    .checkbox-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: ${({ iconSize }) => sizeMap[iconSize].checkboxSize};
        width: ${({ iconSize }) => sizeMap[iconSize].checkboxSize};
    }
    .checkbox-icon {
        padding: 4px;
        overflow: visible;
        color: ${({ theme }) => theme.colors.icon.primary};
    }
    .label {
        white-space: pre-wrap;
    }
`

interface NoSelectedContainerProps {
    size: CheckboxSize
}

export const StyledNoSelectedContainer = styled.div<NoSelectedContainerProps>`
    display: inline-flex;
    height: ${({ size }) => sizeMap[size].outlineSize};
    padding: 0px 12px 0px 11px;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[200]};
    flex-shrink: 0;
    border-radius: 4px;
    border-left: 1px solid ${({ theme }) => theme.colors.border.disable};
`

interface StyledCheckboxProps extends CheckboxProps {
    iconSize: CheckboxSize
}

export const StyledCheckbox = styled(Checkbox)<StyledCheckboxProps>(({ iconSize, disabled, theme }) => ({
    '&.MuiCheckbox-root': {
        display: 'flex',
        padding: 0,
        alignItems: 'flex-start',
        color: theme.colors.surface.neutralAction,
        '&.Mui-disabled': {
            color: theme.colors.surface.disable,
        },
        '&.Mui-checked': {
            color: disabled ? theme.colors.surface.disable : theme.colors.surface.action,
        },
        '&.MuiCheckbox-indeterminate': {
            color: disabled ? theme.colors.surface.disable : theme.colors.surface.action,
        },
        '&.Mui-focusVisible': {
            width: sizeMap[iconSize].outlineSize,
            height: sizeMap[iconSize].outlineSize,
            boxSizing: 'border-box',
            borderRadius: '4px',
            border: `2px solid ${theme.colors.border.actionFocus}`,
        },
    },
    '& .MuiSvgIcon-root': {
        fontSize: sizeMap[iconSize].checkboxSize,
    },
}))
